import {connect} from "react-redux";
import ValletAccount from "./Save";
import {bindActionCreators} from "redux";
import {saveAccount, accountById} from "../../../../service/Valet/action";
import {locationPinCode, locationCity, locationZone, locationArea, stateAndRegion} from "../../../../service/locations/action";

const mapStateToProps = (state) => ({
    saveDetails:state.Valet.saveAccountDetails,
    pincodeData: state.locationReducer.pincodeData,
    cities: state.locationReducer.cities,
    zones: state.locationReducer.zones,
    areas: state.locationReducer.areas,
    accountDetailsByIdData:state.Valet.accountById,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            saveAccount,
            locationCity,
            locationPinCode,
            locationZone,
            locationArea,
            stateAndRegion,
            accountById
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ValletAccount);
